import { PunchoutAuditOutcome, PunchoutOrderIntakeStatus } from '../models/punchout';

/** Bootstrap badge class for an order-intake status, shared by the list and the detail modal. */
export function punchoutIntakeStatusBadgeClass(status?: PunchoutOrderIntakeStatus): string {
  switch (status) {
    case 'PROCESSED':
      return 'bg-success';
    case 'FAILED':
      return 'bg-danger';
    case 'DUPLICATE':
      return 'bg-warning text-dark';
    case 'RECEIVED':
      return 'bg-secondary';
    default:
      return 'bg-light text-dark';
  }
}

/** Bootstrap badge class for a derived cart-transfer outcome. */
export function punchoutAuditOutcomeBadgeClass(outcome?: PunchoutAuditOutcome): string {
  switch (outcome) {
    case 'OK':
      return 'bg-success';
    case 'FAILED':
      return 'bg-danger';
    default:
      return 'bg-light text-dark';
  }
}
